import type { ControllerModule } from './helpers'
import { modulesByControllerName } from './helpers'

// Keep public first-action controls here. Other controllers still resolve through
// the full registry when customer HTML or an AJAX response introduces them.
export const PUBLISHED_CONTROLLERS = modulesByControllerName(
  import.meta.glob<ControllerModule>([
    '../../../components/builder/**/*_controller.js',
    '!../../../components/builder/editor/**/*_controller.js',
    '!../../../components/builder/style_guide/**/*_controller.js',
    '../../../components/form/**/*_controller.js',
    // Standard builder elements also render these shared public components.
    '../../../components/custom_field/section_component_controller.js',
    '../../../components/community/events/calendar_component_controller.js',
    '../../../components/contracts/*_controller.js',
    '../../../components/events/countdown_badge_component_controller.js',
    '../../../components/events/registration_form_component_controller.js',
    '../../../components/products/card_component_controller.js',
    '../../../components/surveys/custom_fields_component_controller.js',
    '../../../components/surveys/responses/multi_page_component_controller.js',
    '../../../components/testimonials/**/*_controller.js',
    '../../../components/tiptap/**/*_controller.js',
    '../text_decoration/*_controller.js',
    '../address_field_controller.js',
    '../altcha_controller.js',
    '../capacity_hold_modal_controller.js',
    '../click_on_connect_controller.js',
    '../collapsible_content_controller.js',
    '../confirm_controller.js',
    '../custom_field_form_controller.js',
    '../dynamic_field_size_controller.js',
    '../embedded_iframe_controller.js',
    '../events/bottom_cta_controller.js',
    '../events/livestream_join_controller.js',
    '../field_with_other_option_controller.js',
    '../input_start_controller.js',
    '../intersection_observer_controller.js',
    '../move_element_controller.js',
    '../parallax_controller.js',
    '../phone_field_controller.js',
    '../popover_controller.js',
    '../resize_handle_controller.js',
    '../revealable_controller.js',
    '../searchable_list_controller.js',
    '../session_checker_controller.js',
    '../side_panel_controller.js',
    '../sticky_scroll_controller.js',
    '../theme_switcher_controller.js',
    '../utils_controller.js',
    '../../../components/bottom_sheet_component_controller.js',
    '../../../components/calendar_component_controller.js',
    '../../../components/carousel_component_controller.js',
    '../../../components/confirm_modal_component_controller.js',
    '../../../components/countdown_component_controller.js',
    '../../../components/cursor_paginator_component_controller.js',
    '../../../components/dropdown_component_controller.js',
    '../../../components/iframe_component_controller.js',
    '../../../components/inline_editor_component_controller.js',
    '../../../components/lazy_content_component_controller.js',
    '../../../components/map_component_controller.js',
    '../../../components/menu_component_controller.js',
    '../../../components/modal_component_controller.js',
    '../../../components/notice_manager_component_controller.js',
    '../../../components/panes_component_controller.js',
    '../../../components/portalled_content_component_controller.js',
    '../../../components/prompt_modal_component_controller.js',
    '../../../components/screen_size_field_component_controller.js',
    '../../../components/re_renderable_component_controller.js',
    '../../../components/revealable_content_container_component_controller.js',
    '../../../components/revealable_content_switch_component_controller.js',
    '../../../components/switch_component_controller.js',
    '../../../components/tabs_component_controller.js',
    '../../../components/truncated_html_component_controller.js',
    '../../../components/yes_no_component_controller.js',
    '../../../components/toasts/*_controller.js',
    '../../../components/video_js/custom_extension_controller.js',
    '../../../components/video_js/with_remove_button_component_controller.js',
  ])
)
